import React from 'react';
import { Mail } from 'lucide-react';

const TermsOfServicePage = () => {
  return (
    <div className="min-h-screen bg-slate-50 py-12" data-testid="terms-page">
      <div className="container mx-auto px-4 sm:px-6 md:px-12 max-w-4xl">
        <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-8 font-heading text-center">
          Terms of Service
        </h1>
        
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 sm:p-10">
          <div className="prose prose-slate max-w-none text-center">
            
            <h2 className="text-xl font-bold text-slate-900 mt-0 mb-4">1. Introduction</h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              Welcome to AuctionGuru. By accessing or using our platform, you agree to these Terms of Service.
            </p>

            <h2 className="text-xl font-bold text-slate-900 mb-4">2. Nature of Service</h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              AuctionGuru is a property aggregation and discovery platform. We collect and display summary information about auction properties from publicly available sources and direct users to third-party websites for full details.
            </p>
            <p className="text-slate-600 leading-relaxed mb-6 font-medium">
              We are not an auctioneer, estate agent, or property seller.
            </p>

            <h2 className="text-xl font-bold text-slate-900 mb-4">3. Third-Party Content</h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              All property listings originate from third-party auction houses. We do not guarantee the accuracy, completeness, or timeliness of this information.
            </p>
            <p className="text-slate-600 leading-relaxed mb-6">
              Users must verify all property details directly with the relevant auction house.
            </p>

            <h2 className="text-xl font-bold text-slate-900 mb-4">4. Use of Platform</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              You agree to use AuctionGuru only for lawful purposes. You must not:
            </p>
            <ul className="list-disc list-inside text-slate-600 mb-6 space-y-2 text-left max-w-md mx-auto">
              <li>Attempt to scrape or extract data from our platform</li>
              <li>Interfere with the platform's operation</li>
              <li>Use the platform for fraudulent purposes</li>
            </ul>

            <h2 className="text-xl font-bold text-slate-900 mb-4">5. External Links</h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              AuctionGuru contains links to third-party websites. We are not responsible for the content, policies, or practices of those websites.
            </p>

            <h2 className="text-xl font-bold text-slate-900 mb-4">6. Intellectual Property</h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              All trademarks, logos, and listing content belong to their respective owners. AuctionGuru does not claim ownership over third-party property listings.
            </p>

            <h2 className="text-xl font-bold text-slate-900 mb-4">7. Limitation of Liability</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              AuctionGuru shall not be held liable for:
            </p>
            <ul className="list-disc list-inside text-slate-600 mb-6 space-y-2 text-left max-w-md mx-auto">
              <li>Any inaccuracies in listings</li>
              <li>Financial decisions made based on platform data</li>
              <li>Any issues arising from third-party auction participation</li>
            </ul>

            <h2 className="text-xl font-bold text-slate-900 mb-4">8. Changes to Service</h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              We may modify or discontinue any part of the platform at any time without notice.
            </p>

            <h2 className="text-xl font-bold text-slate-900 mb-4">9. Contact</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              For any questions or concerns, contact:
            </p>
            <div className="flex items-center justify-center gap-2 text-[#F5A623] font-medium">
              <Mail className="h-5 w-5" />
              <a href="mailto:Support@AuctionGuru.co.uk" className="hover:underline">
                Support@AuctionGuru.co.uk
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
